module.exports = __webpack_public_path__ + "static/media/cooking-oil.03c3e144.jpg";